import { useState, useCallback } from 'react';
/**
 * Generic hook for managing async operations with loading/error states.
 */
export function useAsyncOperation(asyncFunc) {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const execute = useCallback(async (...args) => {
        setLoading(true);
        setError(null);
        try {
            return await asyncFunc(...args);
        }
        catch (err) {
            const errorInstance = err instanceof Error ? err : new Error('Unknown error');
            setError(errorInstance);
            throw errorInstance;
        }
        finally {
            setLoading(false);
        }
    }, [asyncFunc]);
    return { execute, loading, error };
}
//# sourceMappingURL=use-async-operation.js.map